import React from 'react';
import {Container,Grid,styled,Typography} from '@mui/material'
import {Outlet} from 'react-router-dom';
import '../helpers/TeamMembers.css'


function TeamDetailGo() {
  return (
    <>
        <div className='TeamDetailGoInfo TeamDetailPosition-L1'></div>
        <button className='TeamDetailGoInfo-L1 TeamDetailPosition-L2'>
                <p>Detaya Git</p>
        </button>

        <Outlet/>
    </>
    
  )
}

export default TeamDetailGo;